<app-loading
  [loading] = loading
></app-loading>

<ng-container *ngIf="!isModal">
  <app-header></app-header>
  <app-sidebar></app-sidebar>
  <div class="content-wrapper">
    <section class="content">
      <app-breadcrumb
        Titulo="Novo atendimento"
        Pagina="Novo"
        [TemPaginaPai] = true
        LinkPaginaPai="/cadastro/atendimento"
        PaginaPai="Atendimento"
      ></app-breadcrumb>
      <div class="row" style="width: 101%">
        <div class="col-md-12">
          <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
        </div>
      </div>
    </section>
  </div>
</ng-container>

<div class="modal-overlay" *ngIf="isModal && modalNovoAtendimento" (click)="!loading && fecharModal()">
  <div class="box-atendimento-novo" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-phone"></i> Novo Atendimento
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close" [disabled]="loading"></button>
      </div>
    </div>
    <hr>
    <div class="modal-body p-0">
      <ng-container [ngTemplateOutlet]="formTemplate"></ng-container>
    </div>
  </div>
</div>

<ng-template #formTemplate>
  <div [ngClass]="{'card card-blue': !isModal}">
    <form [formGroup]="formCadastrar" id="formCadastrar">
      <div [ngClass]="{'card-body': !isModal}">
        <div class="row">
          <div class="col-md-12 mb-3">
            <div class="form-group">
              <label for="descricao">Declaração resumida:</label>
              <input type="text" id="descricao"
                     placeholder="Digite a descrição resumida do atendimento."
                     [ngClass]="{'is-invalid': formCadastrar.get('descricao')?.invalid && formCadastrar.get('descricao')?.touched}"
                     formControlName="descricao" class="form-control">
              <span id="descricao-error-required" class="error mensagem-erro"
                    *ngIf="formCadastrar.get('descricao')?.touched &&
                    formCadastrar.get('descricao')?.errors?.required"
              >A descrição resumida não pode ser vazia <br></span>
              <span id="descricao-error-max-length" class="error mensagem-erro"
                    *ngIf="formCadastrar.get('descricao')?.touched &&
                    formCadastrar.get('descricao')?.errors?.maxlength"
              >A descrição resumida não pode ser vazia <br></span>
            </div>
          </div>
          <div [ngClass]="isModal ? 'col-md-12 mb-3' : 'col-md-5 mb-3'">
            <div class="form-group">
              <label for="pessoaId">Solicitante</label>
              <div class="custom-select-container">
                <i class="fa fa-user icon"></i>
                <ng-select
                  id= "pessoaId"
                  [items]="itensSolicitantes | async"
                  bindLabel="descricao"
                  bindValue="id"
                  placeholder="Selecione o solicitante."
                  (change)="selecionarCliente($event)"
                  [ngClass]="{'is-invalid': formCadastrar.get('pessoaId')?.invalid && formCadastrar.get('pessoaId')?.touched}"
                  formControlName="pessoaId">
                </ng-select>
              </div>
              <span class="error mensagem-erro"
                    *ngIf="formCadastrar.get('pessoaId')?.touched &&
                    formCadastrar.get('pessoaId')?.errors?.required"
              >O solicitante deve ser selecionado <br></span>
              <div class="d-flex justify-content-between align-items-center mt-1">
                <div class="microbotao" *ngIf="clienteTipoDocumento">{{clienteTipoDocumento}}: {{clienteDocumento}}</div>
                <div class="microbotao" style="cursor: pointer;" (click)="modalCliente()">+ Cliente</div>
              </div>
            </div>
          </div>
          <div [ngClass]="isModal ? 'col-md-6 mb-3' : 'col-md-2 mb-3'">
            <div class="form-group">
              <label for="telefoneSolicitante">Telefone</label>
              <input type="text" id="telefoneSolicitante"
                     mask="(00) 0 0000-0000||(00) 0000-0000"
                     placeholder="Digite o telefone."
                     [ngClass]="{'is-invalid': formCadastrar.get('telefoneSolicitante')?.errors}"
                     formControlName="telefoneSolicitante" class="form-control">
            </div>
          </div>
          <div class="col-md-12 mb-3">
            <div class="form-group">
              <label for="descricaoInicial">Declaração inicial:</label>
              <angular-editor id="descricaoInicial"
                              [config]="editorConfig"
                              [ngClass]="{'is-invalid': formCadastrar.get('descricaoInicial')?.invalid && formCadastrar.get('descricaoInicial')?.touched}"
                              formControlName="descricaoInicial"></angular-editor>
              <span class="error mensagem-erro"
                    *ngIf="formCadastrar.get('descricaoInicial')?.touched &&
                    formCadastrar.get('descricaoInicial')?.errors?.required"
              >A declaração inicial não pode ser vazia <br></span>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 d-flex justify-content-end gap-2 mt-4">
            <button type="button" class="btn btn-light" (click)="voltar()" [disabled]="loading">
              {{ isModal ? 'Cancelar' : 'Voltar' }}
            </button>
            <button type="button" class="btn btn-primary px-4 d-flex align-items-center gap-2" (click)="salvar()" [disabled]="loading || formCadastrar.invalid">
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ loading ? 'Salvando...' : 'Salvar' }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<app-novo-cliente
  [habilitarNovo]="showModalCliente"
  (fecharModalCalled)="fecharModalCliente()"
  (atualizarListaCalled)="listarClientes()"
></app-novo-cliente>
